import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
const ScanListDropdown = ({showScanListDropdown,scanFilterKeyword,setScanDetailsHandler}) => {
  const { scan_list } = useSelector((state) => state);
  // const scan_list=[{"scan_name":"chest"},{"scan_name":"x ray"},{"scan_name":"pantu"},{"scan_name":"chest1"},{"scan_name":"x ray2"},{"scan_name":"pantu3"},
  // {"scan_name":"chest3"},{"scan_name":"x ray3"},{"scan_name":"pantu4"},{"scan_name":"chest14"},{"scan_name":"x cay24"},{"scan_name":"pcntu35"}]
  const [scanList,setScanList]=useState([])
  const [showDropDown, setShowDropDown] = useState(showScanListDropdown);
  const [isHoveredOnScan, setIsHoveredOnScan] = useState("");
  const handleMouseEnter = (scan_name) => {
    setIsHoveredOnScan(scan_name);
  };
  const handleMouseLeave = (scan_name) => {
    setIsHoveredOnScan(scan_name);
  };

  function filterScanListByKeyword(keyword) {
    const lowerKeyword = keyword.toLowerCase();
    const filteredList = scan_list.filter(obj =>{
      if(obj.scan_name.toLowerCase().includes(lowerKeyword)){
        return obj
      }}
    );
    setScanList(filteredList)
  }

  useEffect(() => {
    filterScanListByKeyword(scanFilterKeyword)
  }, [scanFilterKeyword]);

  useEffect(() => {
    if (showDropDown) {
        setShowDropDown("");
      } else {
        setShowDropDown("");
      }
  }, [showScanListDropdown]);
 

  return (
    <div style={{ position: "relative",backgroundColor:"white" }}>
      <div>
        <div
          style={{
            border: "1px solid lightgray ",
            position: "absolute",
            width: "100%",
            left: "-0px",
            display:showDropDown,
            overflowY: "auto",
            background: "white",
            maxHeight:"200px"
          }}
        >
          {scanList.length==0 && <div style={{padding:"10px"}}>No data to display.</div>}
          {scanList.length!=0  && 
              scanList.map(item=>{
              return  <div
                  key={item.scan_name}
                  onMouseEnter={()=>{handleMouseEnter(item.scan_name)}}
                  onMouseLeave={()=>{handleMouseLeave(item.scan_name)}}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:isHoveredOnScan ==item.scan_name?"#e4dddd":"white",
                    cursor:"pointer"
                  }}
                  onClick={()=>{setScanDetailsHandler(item.scan_name)}}
                >
                  <div style={{ fontSize: "15px",padding:"10px" }} >{item.scan_name}</div>
                </div>
              })
          }
        </div>
      </div>
    </div>
  );
};

export default ScanListDropdown;
